import { render } from "./user-wallet-modal.vue?vue&type=template&id=064757c7"
import script from "./user-wallet-modal.vue?vue&type=script&lang=js"
export * from "./user-wallet-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__